module.exports = __webpack_public_path__ + "static/media/hours-icon.61fbd77d.svg";